import { FAMILY_NAMES, marketFamily, type Fork } from '../../lib/protocol';

/** Лайв ленты — ставка во время матча, прематч — до него. */
export function planTiming(line: string | undefined): string {
  if (line === 'live') return 'during';
  if (line === 'prematch') return 'before';
  return '';
}

/** Семейство рынка ленты. Пустой рынок не называем «прочее». */
export function planMarket(fork: Pick<Fork, 'market' | 'sport'>): string {
  const raw = typeof fork.market === 'string' ? fork.market.trim() : '';
  if (raw === '') return '';
  const name = FAMILY_NAMES[marketFamily(fork as Fork)];
  return name === 'прочее' ? raw : name;
}

export type CashStep = { kind: string; id: string; title: string; name: string };

/** Планы с ленты стоят в очереди проверки раньше старых дыр. */
export function stepsWithDrafts(
  drafts: readonly { id: string; data?: { name?: unknown } }[],
  queue: readonly CashStep[],
): CashStep[] {
  const plans = drafts.map((draft) => ({
    kind: 'draft',
    id: draft.id,
    title: 'дописать план из ленты',
    name:
      typeof draft.data?.name === 'string' && draft.data.name !== ''
        ? draft.data.name
        : 'сделка',
  }));
  return [...plans, ...queue];
}

/** Ссылка с ленты открывает сделку, даже если период отчёта её не показывает. */

export function cashTradeKnown(
  report: {
    trades: readonly { id: string }[];
    relatedTrades?: readonly { id: string }[];
  },
  id: string,
): boolean {
  return (
    report.trades.some((trade) => trade.id === id) ||
    (report.relatedTrades ?? []).some((trade) => trade.id === id)
  );
}
